import React, { useState } from "react";
import Slider from "react-slick";
import "./Header.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import Modal from "../Home/Modal";  // <-- Import Modal component

import flowerImage1 from "../Assests/himg7.jpg";
import flowerImage2 from "../Assests/img36.jpg";
import flowerImage3 from "../Assests/img11.jpg";

// Slick carousel settings
const settings = {
  dots: true, 
  infinite: true, 
  speed: 2000, 
  slidesToShow: 1,  
  slidesToScroll: 1,
  autoplay: true, 
  autoplaySpeed: 5000, 
  arrows: true,
};

// Slides Data
const slides = [
  { 
    id: 1, 
    title: "Branded Product Our Expertise ", 
    text: "We specialize in providing top-quality branded products, ensuring excellence, reliability, and trust in the pharmaceutical industry.", 
    button: "Learn More", 
    image: flowerImage1,
    longDescription: `In the pharmaceutical industry, standing out is crucial. At HospiPharma, we help you build strong brand recognition by creating high-quality packaging, attractive labels, and marketing materials that reflect your brand's core values and mission.`
  },
  { 
    id: 2, 
    title: "Compassionate Care for Every Need.", 
    text: "At HospiPharma, we are dedicated to providing innovative healthcare solutions, ensuring every hospital delivers the highest quality care with compassion and excellence.", 
    button: "Read More", 
    image: flowerImage2,
    longDescription: `At HospiPharma, we understand the importance of compassionate care. Our team of experts works closely with hospitals to ensure that patient care remains a top priority. With our advanced medical solutions, hospitals can provide top-quality services.`
  },
  { 
    id: 3, 
    title: "Pricing that Works for Healthcare.", 
    text: "HospiPharma offers transparent and cost-effective pricing, ensuring hospitals get the best healthcare solutions without compromising on quality.", 
    button: "Learn More", 
    image: flowerImage3,
    longDescription: `Our pricing model is designed to be affordable for every hospital. We believe that high-quality healthcare solutions should not come with a hefty price tag. HospiPharma offers transparent pricing for premium healthcare services.`
  },
];

const Header = () => {
  const [selectedSlide, setSelectedSlide] = useState(null);

  // Function to open modal
  const handleOpenModal = (slide) => {
    setSelectedSlide(slide);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setSelectedSlide(null);
  };

  return (
    <div className={`header-container ${selectedSlide ? 'blur-background' : ''}`}> 
      <Slider {...settings}>  
        {slides.map((slide) => (
          <div className="header-slide" key={slide.id}>
            <div className="header-content">
              {/* Left Text Section */}
              <div className="header-text">
                <h1>{slide.title}</h1>
                <p>{slide.text}</p>
                <button 
                  className="header-btn" 
                  onClick={() => handleOpenModal(slide)}
                >
                  {slide.button}
                </button>
              </div>

              {/* Right Image Section */}
              <div className="header-image-container">
                <div className="header-image">
                  <img src={slide.image} alt={slide.title} />
                </div>
              </div>

              {/* Right Side Stats */}
              <div className="header-stats">
                <div className="stat-item"><h2>100%</h2><p>Proximity Product's</p></div>
                <div className="stat-item"><h2>9,00,000+</h2><p>Molecules</p></div>
                <div className="stat-item"><h2>4000+</h2><p>Companies</p></div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Render Modal */}
      {selectedSlide && (
        <Modal slide={selectedSlide} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default Header;
